module.exports = __webpack_public_path__ + "static/media/cbre.f973f9ec.png";